export const testimonials = [
  {
    id: 1,
    name: 'Carlos M.',
    rating: 5,
    text: 'Las mejores hamburguesas de Managua, sin discusión. La Capital Burger es una obra de arte. El ambiente deportivo con pantallas gigantes es increíble.',
    source: 'Google',
    avatar: 'CM'
  },
  {
    id: 2,
    name: 'María Fernanda',
    rating: 5,
    text: 'Fuimos a un tributo de Shakira y la pasamos increíble. La comida deliciosa, los cócteles perfectos y el ambiente espectacular. Volveremos seguro.',
    source: 'Google',
    avatar: 'MF'
  },
  {
    id: 3,
    name: 'Roberto A.',
    rating: 4,
    text: 'Las costillas ahumadas son brutales. Buen servicio, buena música y los precios son justos para la calidad que ofrecen.',
    source: 'PedidosYa',
    avatar: 'RA'
  },
  {
    id: 4,
    name: 'Daniela V.',
    rating: 5,
    text: 'El mejor spot para ver fútbol con amigos en Managua. Las alitas buffalo son adictivas y la torre de cerveza es perfecta para grupos.',
    source: 'Google',
    avatar: 'DV'
  },
  {
    id: 5,
    name: 'Javier L.',
    rating: 5,
    text: 'Pedimos delivery por PedidosYa y la hamburguesa llegó caliente y perfecta. La Spicy Capital es brutal. Recomendadísimo.',
    source: 'PedidosYa',
    avatar: 'JL'
  },
  {
    id: 6,
    name: 'Sofía R.',
    rating: 4,
    text: 'Los almuerzos ejecutivos son la mejor relación calidad-precio de la zona. Arrachera con tostones por C$260 es un robo (a nuestro favor).',
    source: 'Google',
    avatar: 'SR'
  }
]
